import LocalizationModule from '../../configs/localization/localization';
import Rx from 'rx';
import EventEmitter from '../../services/eventEmitter';
import TimeframeCalendarDayModule from './timeframe-calendar-day';
import template from './timeframe-calendar.jade';

export class TimeframeCalendarController {
  /* @ngInject */
  constructor($timeout,$filter) {
    this.timeout = $timeout;
    this.translate = $filter('translate');
    this.current = moment(this.date||this.endDate).add(this.offset,'month').toDate();
    this.buildWeeks();
    this.events = this.events || new EventEmitter();
    this.events.on('goto', (goToDate) => {
      this.current = moment(goToDate).add(this.offset,'month').toDate();
      this.buildWeeks();
    });
    this.events.on('next', () => {
      this.current = moment(this.current).add(1,'month').toDate();
      this.buildWeeks();
    })
    this.events.on('prev', () => {
      this.current = moment(this.current).subtract(1,'month').toDate();
      this.buildWeeks();
    });
    this.comparedEvents = this.comparedEvents || new EventEmitter();
    this.comparedEvents.on('changed', () => {
      this.timeout(() => this.select(this.startDate));
    });
  }

  resetTimezone(date){
    var offset = new Date().getTimezoneOffset();
    var dateTimestamp = Date.parse(date);
    var dateUtcTimestamp = dateTimestamp - (offset * 60 * 1000);
    var dateUtcDate = new Date(dateUtcTimestamp);
    return dateUtcDate;
  }

  buildWeeks() {
    let day = moment(this.current).startOf('month').startOf('isoweek');
    let endDate = moment(this.current).endOf('month').endOf('isoweek');

    let weeks = [];

    while (day <= endDate) {
      let endOfWeek = day.clone().endOf('isoweek');
      let days = [];
      while (day <= endOfWeek) {
        days.push(this.resetTimezone(day.toDate()));
        day = day.clone().add(1, 'd');
      }
      weeks.push(days);
    }
    this.weeks = weeks;
  }
  calendarClasses(){
    return _.pickBy({
      'is-range': this.isRange,
      'is-comparison': this.isComparison,
      'is-selecting-end-date': this.selecting == 'endDate'
    }, value => value);
  }
  select(date){
    if (this.isRange) {
      if (this.selecting != 'endDate') {
        this.selecting = 'endDate';
        this.startDate = date;
        this.endDate = null;
        this.hoveredDate = null;
      } else {
        if (moment(date).diff(this.startDate) >= 0) {
          this.selecting = 'startDate';
          this.endDate = date;
        }
      }
      this.events.emit('changed', [this.startDate,this.endDate]);
    } else if (this.isComparison) {
      let startDate = date;
      let comparedPeriodDiff = moment(this.comparedEndDate).diff(this.comparedStartDate, 'days');
      let endDate = moment(startDate).add(comparedPeriodDiff, 'days').startOf('day').hours(startDate.getHours()).toDate();
      let futureDiff = moment(endDate).diff(moment().startOf('day').hours(moment().getHours()), 'days');
      if (futureDiff > 0) {
        startDate = moment(startDate).subtract(futureDiff, 'days').toDate();
        endDate = moment(endDate).subtract(futureDiff, 'days').toDate();
      }
      this.startDate = startDate;
      this.endDate = endDate;
      this.events.emit('changed', [this.startDate,this.endDate]);
    } else {
      this.date = date;
      this.events.emit('changed', this.date);
    }
  }
  hover(date){
    if (this.isRange && this.selecting == 'endDate') {
      let isDifferentMonth = date.getFullYear() != this.current.getFullYear() ||
        date.getMonth() != this.current.getMonth();

      if (!isDifferentMonth) {
        this.hoveredDate = date;
        this.events.emit('hovered', this.date);
      }
    }
  }
  get isRange(){
    return /range/.test(this.mode);
  }
  get isComparison(){
    return /comparison/.test(this.mode);
  }
}

export function TimeframeCalendarComponent() {
  return {
    template,
    controller: TimeframeCalendarController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      mode: '@',
      offset: '@',
      hide: '=?',
      events: '=?',
      selecting: '=?',
      hoveredDate: '=?',
      date: '=?',
      startDate: '=?',
      endDate: '=?',
      comparedEvents: '=?',
      comparedStartDate: '=?',
      comparedEndDate: '=?'
    },
    bindToController: true
  };
};

export default angular.module('app.datetime.timeframe-calendar', [
  LocalizationModule.name,
  TimeframeCalendarDayModule.name
])
  .directive('timeframeCalendar', TimeframeCalendarComponent);



/** WEBPACK FOOTER **
 ** ./src/common/datetime/timeframe-calendar.js
 **/